import Navbar from "../Navbar";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import { Outlet } from "react-router-dom";

export default function PrivateLayout() {
  return (
    <div className="app">
      <Navbar />

      <div className="app-body">
        <Sidebar />
        <div className="app-content">
          <Outlet />
        </div>
      </div>

      <Footer />
    </div>
  );
}